import { mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize } from '@/styles/typography/utils';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  ${mediaBreakpointUp('desktop')} {
    gap: 80px;
  }

  ${mediaBreakpointUp('desktopWide')} {
    gap: 120px;
  }
`;

const Heading = styled.h2`
  ${customTextSize(24, 30)}
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  text-align: center;
  letter-spacing: -0.01em;

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(32, 38)}
  }

  ${mediaBreakpointUp('desktopWide')} {
    ${customTextSize(49, 58)}
  }
`;

const Description = styled.div`
  ${customTextSize(16, 24)};
  text-align: center;
  margin-top: 1.5rem;

  a {
    text-decoration: underline;
    font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  }

  ${mediaBreakpointUp('desktopWide')} {
    ${customTextSize(24, 34)}
  }
`;

const featureGroupComponents = {
  Wrapper,
  Heading,
  Description,
};

export default featureGroupComponents;
